/**
 * Strings of the "Images" page (recognise handwritten characters), FR and EN.
 * Task name and kit strings come from the contribution kit.
 */
export const labelImagesCopy = {
  fr: {
    title: "Reconnaissez des caractères manuscrits",
    description: "Une image montre un caractère écrit à la main. Indiquez lequel, image après image.",
    statImages: "Images par session",
    statMinutes: "Minutes environ",
    instruction1: "Regardez attentivement chaque caractère manuscrit.",
    instruction2: "Choisissez sur le clavier le caractère qui correspond le mieux à l'image.",
    instruction3: "En cas de doute, donnez votre meilleure réponse : elle compte.",
    instruction4: "Vous pouvez passer une image illisible.",
    setupNote: "Chaque session tire de nouvelles images au hasard.",
    start: "Commencer",
    loading: "Préparation des images...",
    errorTitle: "La session n'a pas pu démarrer",
    back: "Retour",
    imageXofY: "Image {current} sur {total}",
    toIdentify: "À identifier",
    imageAlt: "Caractère manuscrit {index}",
    question: "Quel caractère voyez-vous dans cette image ?",
    answerLabel: "Votre réponse",
    slotEmpty: "Touchez pour ouvrir le clavier",
    slotLabel: "Caractère choisi : {value}. Ouvrir le clavier",
    keyboard: "Clavier",
    previous: "Précédente",
    skip: "Passer",
    validate: "Valider",
    finish: "Terminer",
    stepCorrect: "Correcte",
    stepWrong: "Incorrecte ou passée",
    stepCurrent: "En cours",
    stepTodo: "À faire",
    answered: "{answered} / {total} répondues",
    accuracy: "Précision : {accuracy} %",
    doneTitle: "Merci pour vos réponses",
    doneDescription: "Vos réponses aident à améliorer la reconnaissance d'écriture.",
    doneAccuracy: "Précision",
    doneCorrect: "Correctes",
    doneTotal: "Images",
    doneContinue: "Contribuer à nouveau",
    doneHint: "Chaque session tire de nouvelles images au hasard.",
  },
  en: {
    title: "Recognise handwritten characters",
    description: "Each image shows a character written by hand. Say which one, image after image.",
    statImages: "Images per session",
    statMinutes: "Minutes or so",
    instruction1: "Look carefully at each handwritten character.",
    instruction2: "Pick on the keyboard the character that best matches the image.",
    instruction3: "If unsure, give your best answer: it counts.",
    instruction4: "You can skip an unreadable image.",
    setupNote: "Each session draws new random images.",
    start: "Start",
    loading: "Preparing the images...",
    errorTitle: "The session could not start",
    back: "Back",
    imageXofY: "Image {current} of {total}",
    toIdentify: "To identify",
    imageAlt: "Handwritten character {index}",
    question: "Which character do you see in this image?",
    answerLabel: "Your answer",
    slotEmpty: "Tap to open the keyboard",
    slotLabel: "Chosen character: {value}. Open the keyboard",
    keyboard: "Keyboard",
    previous: "Previous",
    skip: "Skip",
    validate: "Validate",
    finish: "Finish",
    stepCorrect: "Correct",
    stepWrong: "Wrong or skipped",
    stepCurrent: "Current",
    stepTodo: "To do",
    answered: "{answered} / {total} answered",
    accuracy: "Accuracy: {accuracy}%",
    doneTitle: "Thank you for your answers",
    doneDescription: "Your answers help improve handwriting recognition.",
    doneAccuracy: "Accuracy",
    doneCorrect: "Correct",
    doneTotal: "Images",
    doneContinue: "Contribute again",
    doneHint: "Each session draws new random images.",
  },
} as const;

export type LabelImagesCopy = { [K in keyof (typeof labelImagesCopy)["fr"]]: string };
